import type { ReactNode } from 'react';

export const symbol_shield_card: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M520-80q-24 0-42-18t-18-42v-220q0-24 18-42t42-18h340q24 0 42 18t18 42v220q0 24-18 42t-42 18H520Zm0-60h340v-100H520v100Zm0-160h340v-60H520v60Zm-40-199ZM367-131q-97-63-152-170.05Q160-408.09 160-523v-196q0-19.26 10.88-34.66Q181.75-769.07 199-776l268-100q5.71-2 12.86-2 7.14 0 13.14 2l268 100q17.25 6.93 28.13 22.34Q800-738.26 800-719v209q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-209l-260-98-260 98v196q0 106 49 196.5T400-182q11 7 13.5 19t-4.5 23q-7 11-19 13.5t-23-4.5Z"
		/>
	</svg>
);
